skrilla.filter('scanForDateTime', function($filter) {
    return function(string, format) {
        let apiSpecialFormat = /(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[012])[-]((19|20)[0-9][0-9]) ([01][1-9]|[2][0-9])[:]([0-9][0-9])[:]([0-9][0-9]) ([+|-]([01][0-9]|[2][0-3])[:]([0-5][0-9])){0,1}/ig;
        let isoFormat = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/ig;

        string = string.replaceAll(apiSpecialFormat, function(match, p1, p2, p3, p4, p5, p6, p7){
            var date = p3 + "-" + p2 + "-" + p1 +"T"+ p5 + ":" + p6 + ":" + p7+".0000Z"
            return $filter("dateTimeFormatter")(date)
        });

        string = string.replaceAll(isoFormat, function(match){
            return $filter("dateTimeFormatter")(match)
        });

        return string;
    };
})
